import { useEffect } from "react";

declare global {
  interface Window {
    googleTranslateElementInit?: () => void;
    google?: {
      translate: {
        TranslateElement: new (
          config: { pageLanguage: string; includedLanguages?: string },
          elementId: string
        ) => void;
      };
    };
  }
}

export default function useGoogleTranslate() {
  useEffect(() => {
    const existingScript = document.getElementById(
      "google-translate-api-script"
    );
    if (!existingScript) {
      const script = document.createElement("script");
      script.id = "google-translate-api-script";
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.type = "text/javascript";
      script.defer = true;
      script.async = true;
      document.body.appendChild(script);
    }

    window.googleTranslateElementInit = () => {
      if (window.google?.translate) {
        new window.google.translate.TranslateElement(
          { pageLanguage: "en", includedLanguages: "en,gu,hi" },
          "google_translate_element"
        );
      }
    };

    // Retry initialization after 2 seconds (helps on mobile)
    setTimeout(() => {
      if (typeof window.googleTranslateElementInit === "function") {
        window.googleTranslateElementInit();
      }
    }, 2000);
  }, []);
}
